import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetallePorCondicionLinea4Service {
  static async getDataTablaDetallePorCondicionLinea4 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_etiqueta_sector4')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 4.')
      return (data)
    })
  }

  static async getDataTablaDetallePorCondicionLinea4Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_etiqueta_sector4_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 4.')
      return (data)
    })
  }
}
